import { render, staticRenderFns } from "./SpecialBonusesList.vue?vue&type=template&id=1293b4aa&"
import script from "./SpecialBonusesList.vue?vue&type=script&lang=js&"
export * from "./SpecialBonusesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports